<script lang="ts">
  import ProductLineBox from "@retailer/svelte/ProductDetails/Components/ProductLineBox/ProductLineBox.svelte";
  import DescriptionBox from "@retailer/svelte/ProductDetails/Components/DescriptionBox.svelte";
  import DiscoveryPanel from "@shared/svelte/DiscoveryPanel/DiscoveryPanel.svelte";
  import ProducerDescriptionBox from "@retailer/svelte/ProductDetails/Components/ProducerDescriptionBox.svelte";
  import type { ProductLine, Product } from "@shared/types/ProductLine";
  import type { SalesRep } from "@shared/types/SalesRep";
  import type { Distributor } from "@shared/types/Distributor";
  import type { RetailerDistributor } from "@shared/types/RetailerDistributor";
  import type { SalesDivision, SfProduct, VendorProduct } from "@shared/types/SevenFifty";
  import layoutStore from "@shared/svelte/Stores/LayoutStore";

  export let accountDataLoaded: boolean = false;
  export let productLine: ProductLine;
  export let mobileMode: boolean;
  export let hasDiscount: boolean;
  export let distributor: Distributor;
  export let retailerDistributor: RetailerDistributor;
  export let selectedVintageProduct: Product;
  export let salesReps: SalesRep[];
  export let openConnectDistributorModal: () => void;
  export let discoveryPanelConfig: any[] = [];
  export let pageName: string;
  export let pageValue: string;
  export let distributors: Distributor[];
  export let showDualProductExperience: boolean;
  export let sevenFiftyProduct: SfProduct;
  export let vendorProduct: VendorProduct;
  export let hideAllDistributorInfo: boolean = false;

  let salesDivisions: SalesDivision[];
  $: salesDivisions = vendorProduct?.sales_divisions || [];
</script>

<div
  class="fizz-align-self-start grid-col c10-10 c6-10--md margin-top--small product-detail_product-overview fizz-styles"
  class:fizz-full-width={$layoutStore.isMobile}
>
  <div class:fizz-stack-24={$layoutStore.isDesktop}>
    <ProductLineBox
      bind:hideAllDistributorInfo
      {hasDiscount}
      {productLine}
      {distributor}
      {retailerDistributor}
      {selectedVintageProduct}
      {salesReps}
      {openConnectDistributorModal}
      {accountDataLoaded}
      {mobileMode}
      {distributors}
      {showDualProductExperience}
      producerName={sevenFiftyProduct?.producer_name}
      parentProducerName={sevenFiftyProduct?.parent_producer_name}
      {salesDivisions}
    />

    <DescriptionBox
      {distributor}
      {productLine}
      {selectedVintageProduct}
      {mobileMode}
      {sevenFiftyProduct}
      {vendorProduct}
    />

    <ProducerDescriptionBox
      producerDescription={sevenFiftyProduct?.producer_description}
      {mobileMode}
      productLineId={productLine.id}
    />
  </div>
  {#if mobileMode === false}
    <DiscoveryPanel
      carouselCardsShown={4}
      configuration={discoveryPanelConfig}
      {pageName}
      {pageValue}
      {mobileMode}
    />
  {/if}
</div>
